import React, { Component } from "react";

import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import { Link } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';

const styles = theme => ({
	[theme.breakpoints.down('sm')]:{
		bigcell: {
			maxWidth:'150px',
			minWidth:'50px'
		},
		medcell: {
			maxWidth:'50px',
			minWidth:'50px'
		},
		smallcell: {
			maxWidth:'15px',
			minWidth:'15px'
		},
	},
	[theme.breakpoints.up('md')]:{
		bigcell: {
			maxWidth:'150px',
			minWidth:'50px'
		},
		medcell: {
			maxWidth:'50px',
			minWidth:'50px'
		},
		smallcell: {
			maxWidth:'50px',
			minWidth:'50px'
		},
	},
	setoverflow:{
		overflow:'hidden',
		display: 'block'
	}
});

class NonconformityRow extends Component {
	constructor() {
		super();
	}
	
	
	render() {
		let isueDate = this.props.isueDate ? new Intl.DateTimeFormat('es-ES', {}).format(new Date(this.props.isueDate)) : "";
		let correctionDate = this.props.correctionDate ? new Intl.DateTimeFormat('es-ES', {}).format(new Date(this.props.correctionDate)) : "";
		return (
			<TableRow hover key={this.props.id}>
				<TableCell><span className={this.props.classes.setoverflow}><Link  to={`/nonconformity/${this.props.orderId}`}>{this.props.title}</Link></span></TableCell>
				<TableCell><span className={this.props.classes.setoverflow}>{this.props.orderCode}</span></TableCell>
				<TableCell><span className={this.props.classes.setoverflow}>{isueDate}</span></TableCell>
				<TableCell><span className={this.props.classes.setoverflow}>{correctionDate}</span></TableCell>
			</TableRow>
		);
	}
}

export default withStyles(styles)(NonconformityRow);